/**
 * Shared by the Notifications page and the service worker's push handler, so
 * an in-app tap and a phone notification tap land on the same screen.
 */
export function notifLink(type: string, resourceId?: string | null): string | null {
  if (type === 'ANNOUNCEMENT') return '/announcements';
  if (type.startsWith('ATTENDANCE')) return '/attendance';
  if (type.startsWith('LEAVE')) return resourceId ? `/leave?highlight=${resourceId}` : '/leave';
  if (type.startsWith('CLAIM')) return resourceId ? `/claims?highlight=${resourceId}` : '/claims';
  // Payslips are disabled (payroll deferred) — no navigation target.
  return null;
}
